import PropTypes from 'prop-types';
import React from 'react';
import Sound from 'react-sound';

window.soundManager.setup({ debugMode: false });

const AudioPlayer = React.memo(props => <Sound {...props} />);

AudioPlayer.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string,
  playStatus: PropTypes.oneOf(Object.values(Sound.status)),
  playFromPosition: PropTypes.number,
  position: PropTypes.number,
  volume: PropTypes.number,
  playbackRate: PropTypes.number,
  autoLoad: PropTypes.bool,
  loop: PropTypes.bool,
  onError: PropTypes.func,
  onLoading: PropTypes.func,
  onLoad: PropTypes.func,
  onPlaying: PropTypes.func,
  onPause: PropTypes.func,
  onResume: PropTypes.func,
  onStop: PropTypes.func,
  onFinishedPlaying: PropTypes.func,
  onBufferChange: PropTypes.func,
};

AudioPlayer.defaultProps = {
  className: '',
  url: null,
  playStatus: Sound.status.STOPPED,
  playFromPosition: 0,
  position: 0,
  volume: 100,
  playbackRate: 1,
  autoLoad: false,
  loop: false,
  onError: Function.prototype,
  onLoading: Function.prototype,
  onLoad: Function.prototype,
  onPlaying: Function.prototype,
  onPause: Function.prototype,
  onResume: Function.prototype,
  onStop: Function.prototype,
  onFinishedPlaying: Function.prototype,
  onBufferChange: Function.prototype,
};

AudioPlayer.Status = Sound.status;
AudioPlayer.displayName = 'AudioPlayer';

export default AudioPlayer;
